import React from 'react';
import PropTypes from 'prop-types';

import ReactSelect from 'react-select';
import { injectIntl } from 'react-intl';

import FormInputContainer from './containers/FormInputContainer';
import Toggle from './Toggle';
import {
  ClearIndicator,
  Control,
  DropdownIndicator,
  MultiValueLabel,
  MultiValueRemove,
  Option,
  SelectContainer,
  ValueContainer
} from './selectComponents/';

const Select = ({
  label,
  input,
  options,
  multi,
  title,
  disabled,
  meta,
  forceDropdown,
  initialValue,
  placeholder,
  intl,
  clearable,
  customOptionLabel,
  openOnFocus,
  defaultOption,
  extraClassName,
  isCountry,
  menuIsOpen,
  ...props
}) => {
  const formattedPlaceholder = placeholder && placeholder.id ? intl.formatMessage({ id: placeholder.id }) : placeholder;
  const formattedLabel = label && label.props && label.props.id ? intl.formatMessage({ id: label.props.id }) : label;
  let inputVal = Array.isArray(input.value)
    ? input.value
    : options.filter(opt => opt.value === input.value || opt.value === input.value.value)[0];
  if (!inputVal && isCountry) {
    inputVal = { label: '', value: '' };
  }
  const menuOpen = disabled ? false : menuIsOpen;

  return options.length > 3 || forceDropdown ? (
    <div data-desc={`${title || input.name || formattedLabel || 'select'}__select`} className={extraClassName}>
      <FormInputContainer label={label} meta={meta} title={title} type='select' {...props}>
        <ReactSelect
          value={inputVal}
          input={input}
          defaultValue={defaultOption}
          options={options}
          isMulti={multi}
          blurInputOnSelect
          openMenuOnFocus={openOnFocus}
          isClearable={clearable}
          onBlurResetsInput={false}
          isDisabled={disabled}
          placeholder={formattedPlaceholder}
          formatOptionLabel={customOptionLabel}
          onChange={val => input.onChange(val)}
          classNamePrefix='react-select'
          menuIsOpen={menuOpen}
          components={{
            ClearIndicator,
            Control,
            DropdownIndicator,
            MultiValueLabel,
            MultiValueRemove,
            Option,
            SelectContainer,
            ValueContainer
          }}
          styles={{
            control: () => ({}),
            menu: () => ({}),
            menuList: () => ({}),
            option: () => ({ padding: 0 }),
            valueContainer: () => ({}),
            singleValue: () => ({}),
            multiValue: () => ({})
          }}
        />
      </FormInputContainer>
    </div>
  ) : (
    <Toggle {...props} {...input} title={title} options={options} label={label} disabled={disabled} />
  );
};

Select.defaultProps = {
  label: null,
  initialValue: null,
  intl: null,
  multi: false,
  forceDropdown: false,
  disabled: false,
  clearable: true,
  title: '',
  placeholder: null,
  customOptionLabel: null,
  isCountry: false,
  openOnFocus: false,
  defaultOption: null,
  extraClassName: null,
  menuIsOpen: undefined
};

Select.propTypes = {
  label: PropTypes.any,
  intl: PropTypes.any,
  initialValue: PropTypes.any,
  input: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  multi: PropTypes.bool,
  title: PropTypes.string,
  meta: PropTypes.object.isRequired,
  forceDropdown: PropTypes.bool,
  clearable: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.any,
  customOptionLabel: PropTypes.any,
  isCountry: PropTypes.bool,
  openOnFocus: PropTypes.bool,
  defaultOption: PropTypes.object,
  extraClassName: PropTypes.string,
  menuIsOpen: PropTypes.bool
};

export default injectIntl(Select);
